import { render, staticRenderFns } from "./atlas_block.vue?vue&type=template&id=127b124e&scoped=true&"
import script from "./atlas_block.vue?vue&type=script&lang=js&"
export * from "./atlas_block.vue?vue&type=script&lang=js&"
import style0 from "./atlas_block.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./atlas_block.vue?vue&type=style&index=1&id=127b124e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127b124e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VDialog,VIcon,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\1603014\\develop\\qplus\\qpeplus\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('127b124e', component.options)
    } else {
      api.reload('127b124e', component.options)
    }
    module.hot.accept("./atlas_block.vue?vue&type=template&id=127b124e&scoped=true&", function () {
      api.rerender('127b124e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/atlas/atlas_block.vue"
export default component.exports